import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, SalesStockGroupByOptions, SalesStockStatusOptions, StatusCodeActive } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, CheckUndefined, GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import SmallButton from "components/Button/SmallButton";
import { PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { useCallApi } from "api/apiHooks";

export default function SalesStock(){
    let navigate = useNavigate()

    const { openModal, closeModal } = useModal()
    const { fetchBrandList, fetchSalesStockList, fetchDeleteSalesStock } = useCallApi()

    const [productName, setProductName] = useState('')
    const [stockCode, setStockCode] = useState('')
    const [stockStatus, setStockStatus] = useState(SalesStockStatusOptions[1].value)
    const [groupBy, setGroupBy] = useState(SalesStockGroupByOptions[0].value)
    const [brandOptions, setBrandOptions] = useState('')
    const [brand, setBrand] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)
    const [salesStockList, setSalesStockList] = useState([])
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState('')

    // Button Event
    const addBtnClick = () => {
        navigate("/sales-stock/form?salesStockId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/sales-stock/form?salesStockId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                fetchDeleteSalesStock(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        closeModal()
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            },
        })
    }

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            const res = await fetchSalesStockList(productName, brand === null || brand === '' ? '' : brand.value, stockCode, stockStatus, status, groupBy === '1' ? PageSize : 10000, newIndex, groupBy)

            if (CheckResponse(res)) {
                const totalData = res?.data?.totalData ?? 0;
                const total = Math.max(1, Math.ceil(totalData / PageSize));

                setSalesStockList(res)
                setTotalPages(total);
                setPageIndex(newIndex);
            } else {
                openModal(ModalTypeFail, { message: res.message })
                return
            }
        } finally {
            closeModal();
        }
    }

    useEffect(() => {
        if (firstLoad) {
            openModal(ModalTypeLoading)

            fetchBrandList('', '1', 1000, 0).then((res) => {
                if (CheckResponse(res)) {
                    let data = res?.data?.listData
                    let tempData = [{ label: 'All', value: '' }]

                    data.map((data, i) => tempData.push({ label: data.brandName, value: String(data.brandId)}))

                    setBrandOptions(tempData)
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                }
            }).finally(() => {
                handlePageChange(pageIndex)
            })

            setFirstLaod(false)
        } else {
            openModal(ModalTypeLoading)

            handlePageChange(pageIndex)
        }
    },[brand, productName, stockStatus, status, groupBy])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Sales Stock'/>

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-2">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Brand</span>
                        <Select options={brandOptions} value={brand} onChange={(e) => { setBrand(e) }} placeholder='All' />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Product Name</span>
                        <input className="input" value={productName} onChange={(e) => { setProductName(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-between bg-white p-2 rounded-xl shadow-md text-sm border">
                <div className="flex gap-4">
                    <div className="flex gap-2">
                        { SalesStockStatusOptions.map((data, i) => { return (
                            <div className={`border px-3 flex items-center rounded-full cursor-pointer ${stockStatus === data.value ? 'bg-black text-white' : ''} `}
                                onClick={() => { setStockStatus(data.value) }}
                                key={i}
                            >
                                {data.label}
                            </div>
                        )})}
                    </div>
                    <div className="border-x" />
                    <div className="flex gap-2">
                        { SalesStockGroupByOptions.map((data, i) => { return (
                            <div className={`border px-3 flex items-center rounded-full cursor-pointer ${groupBy === data.value ? 'bg-black text-white' : ''} `}
                                onClick={() => { setGroupBy(data.value) }}
                                key={i}
                            >
                                {data.label}
                            </div>
                        )})}
                    </div>
                </div>
               
               <div>
                    <SmallButton 
                        buttonName='Add Stock'
                        visible={true}
                        onClick={addBtnClick}
                        className='bg-black text-white'
                    />
               </div>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                {groupBy === '1' ? 
                    (
                        <table className="w-full border bg-white">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2">Stock Code</th>
                                    <th className="font-semibold text-left px-2">Product Name</th>
                                    <th className="font-semibold text-left px-2">Size</th>
                                    <th className="font-semibold text-left px-2">Purchase Price</th>
                                    <th className="font-semibold text-left px-2">Stock Status</th>
                                    <th className="font-semibold text-left px-2">Status</th>
                                    <th className="font-semibold w-auto sm:w-24">Action</th>
                                </tr>
                            </thead>
                            <tbody className="border">
                                { salesStockList?.data?.listData?.length === 0 && (
                                    <tr className="text-center h-12">
                                    <td colSpan={8}>No Data Available</td> 
                                    </tr>
                                )}
                                { salesStockList?.data?.listData?.map((data, i) => {
                                    return(
                                        <tr className="my-1 row h-10 border-y hover:bg-slate-100" key={ i }>
                                            <td className="text-center">{ data.rowNumber }</td>
                                            <td className="px-2">
                                                <span>{ data.stockCode }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.brandName } { data.productName }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.size }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>Rp { CheckUndefined(data.purchasePrice) ? money(data.purchasePrice) : '' }</span>
                                            </td>
                                            <td className="px-2 hidden sm:table-cell">
                                                <span>{ SalesStockStatusOptions.find(x => x.value === String(data.stockStatus)).label  }</span>
                                            </td>
                                            <td className="px-2 hidden sm:table-cell">
                                                <span>{ CheckUndefined(data.status) ? GetStatus(data.status) : '' }</span>
                                            </td>
                                            <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                                <button className="button gap-2 flex" onClick={() => editBtnClick(data.salesStockId)}>
                                                    <EditIcon className="w-3 fill-white" />
                                                </button>
                                                <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.salesStockId, data.status)}>
                                                    {data.status === StatusCodeActive ? (<TrashIcon className="w-3 fill-white" />) : (<RevisionIcon className="w-3 fill-white" />)}
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    ) : (
                        <table className="w-full border bg-white">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2">Product Name</th>
                                    <th className="font-semibold text-left px-2">Stock Status</th>
                                    <th className="font-semibold text-left px-2">Total</th>
                                </tr>
                            </thead>
                            <tbody className="border">
                                { salesStockList?.data?.listData?.length === 0 && (
                                    <tr className="text-center h-12">
                                    <td colSpan={4}>No Data Available</td> 
                                    </tr>
                                )}
                                { salesStockList?.data?.listData?.map((data, i) => {
                                    return(
                                        <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                            <td className="text-center">{ i + 1 }</td>
                                            <td className="px-2">
                                                <span>{ data.brandName } { data.productName }</span>
                                            </td>
                                            <td className="px-2 hidden sm:table-cell">
                                                <span>{ SalesStockStatusOptions.find(x => x.value === String(data.stockStatus)).label  }</span>
                                            </td>
                                            <td className="px-2 hidden sm:table-cell">
                                                <span>{ data.totalStock }</span>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    )
                }
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}